import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SEO_PAGES } from "../data/seoPages";
import SEOHead from "../components/SEOHead";

const TICKETED_SLUGS = new Set([
 "nye-cruises-sydney-harbour",
 "vivid-cruises-sydney",
 "australia-day-cruises-sydney-harbour",
 "boxing-day-cruises-sydney",
]);

const HIDDEN_SLUGS = new Set([
 "bucks-party-cruises-sydney-harbour",
]);

export default function CruisesIndex() {
 const privateCharters = SEO_PAGES.filter(p => !TICKETED_SLUGS.has(p.slug) && !HIDDEN_SLUGS.has(p.slug));
 return (
  <main className="pt-32 pb-24" data-testid="cruises-index">
   <SEOHead
    title="Private Charter Cruises Sydney Harbour | Wedding, Corporate, BYO, Hens | Magic"
    description="Every private charter cruise on Sydney Harbour aboard MV Sydney Magic , weddings, corporate events, birthdays, hens, engagements, BYO and bespoke charters for up to 120 guests. King St Wharf 3, Darling Harbour."
    image="https://customer-assets.emergentagent.com/job_magic-harbour-party/artifacts/srsraacs_sydney%20cruises%20boats.png"
    canonical="/cruises"
    keywords="private cruises Sydney Harbour, private boat hire Sydney, wedding cruise Sydney, hens cruise Sydney, BYO cruise Sydney, corporate cruise Sydney"
    includeLocalBusiness
    breadcrumbs={[
     { name: "Home", url: "/" },
     { name: "Private Charter Cruises", url: "/cruises" },
    ]}
   />
   <div className="mx-auto max-w-7xl px-5 lg:px-10">
    <div className="eyebrow">Private charter cruises</div>
    <h1 className="font-display text-4xl lg:text-7xl mt-3 mb-3 text-ink leading-[1]">Every private charter on <span className="text-pink italic">Sydney Harbour</span>.</h1>
    <p className="text-ink-soft max-w-2xl mb-12 text-lg">Birthdays, weddings, corporate functions, hens parties, BYO cruises and bespoke private boat hire. Every cruise below is a private full boat charter for up to 120 guests on the Magic.</p>
    <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
     {privateCharters.map((p) => (
      <Link key={p.slug} to={`/cruises/${p.slug}`} className="group card-pop bg-white rounded-2xl border border-[hsla(222,20%,80%,0.5)] overflow-hidden" data-testid={`cruise-card-${p.slug}`}>
       <div className="aspect-[4/3] overflow-hidden relative">
        <img src={p.image} alt={p.h1} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-[1.2s]" />
        <span className="absolute top-3 left-3 sticker bg-white/95">{p.tag}</span>
       </div>
       <div className="p-5">
        <div className="font-display text-lg text-ink leading-tight">{p.h1}</div>
        <div className="text-xs text-pink uppercase tracking-[0.18em] font-bold mt-3 flex items-center gap-1">Explore <ArrowRight className="w-3 h-3" /></div>
       </div>
      </Link>
     ))}
    </div>
   </div>
  </main>
 );
}
